import '@mui/material/styles';
export const breakpoints = {
    values: {
        xs: 329,
        sm: 768,
        md: 992,
        lg: 1180,
        xl: 1440,
        xxl: 1728,
        xxxl: 3840 // Custom XXXL
    }
};
